import type { ReactNode } from "react";

// Compact action button used in table rows, inline actions, and modals.
// For the marquee CTA on the landing/sign-in screen, use <PrimaryButton>.
type Variant = "primary" | "ghost" | "danger" | "link";

const STYLES: Record<Variant, { bg: string; color: string; border?: string }> = {
  primary: { bg: "#111111", color: "#ffffff" },
  ghost: { bg: "transparent", color: "#0f0f0f", border: "1px solid rgba(0,0,0,0.14)" },
  danger: { bg: "#C61418", color: "#ffffff" },
  link: { bg: "transparent", color: "#0f0f0f" },
};

export function Button({
  children,
  onClick,
  disabled,
  type = "button",
  variant = "ghost",
  size = "md",
  fullWidth,
}: {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  type?: "button" | "submit";
  variant?: Variant;
  size?: "sm" | "md";
  fullWidth?: boolean;
}) {
  const style = STYLES[variant];
  const padding = size === "sm" ? "px-3 py-1.5 text-xs" : "px-4 py-2 text-sm";
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${padding} font-medium rounded-full whitespace-nowrap transition-all disabled:opacity-40 disabled:cursor-not-allowed ${
        variant === "link" ? "underline-offset-2 hover:underline" : ""
      } ${fullWidth ? "w-full" : ""}`}
      style={{
        backgroundColor: style.bg,
        color: style.color,
        border: style.border ?? "none",
      }}
    >
      {children}
    </button>
  );
}
